var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-left" }, [
    _c("div", { staticClass: "sidebar-body scroll-pane" }, [
      _c(
        "div",
        { staticClass: "side-nav" },
        [
          _c(
            "v-collapse",
            { attrs: { accordion: "" } },
            [
              _vm.arrayBarra[0]["state"] === true ||
              _vm.arrayBarra[1]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-line-chart"
                          }),
                          _vm._v("Panel de control\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[0]["state"] === true
                        ? _c("router-link", { attrs: { to: "/admin/menu" } }, [
                            _c("i", { staticClass: "icon-fa icon-fa-bars" }),
                            _vm._v("Menú")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[2]["state"] === true ||
              _vm.arrayBarra[3]["state"] === true ||
              _vm.arrayBarra[4]["state"] === true ||
              _vm.arrayBarra[5]["state"] === true ||
              _vm.arrayBarra[6]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/account" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-bank" }),
                          _vm._v("Cuentas\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[2]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/cuentas" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-money" }),
                              _vm._v("Cuenta")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[3]["state"] === true
                        ? _c("router-link", { attrs: { to: "/admin/cajas" } }, [
                            _c("i", { staticClass: "icon-fa icon-fa-inbox" }),
                            _vm._v("Cajas")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[4]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/transacciones" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-exchange"
                              }),
                              _vm._v("Transacciones")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[5]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/cuentasporcobrar/lista" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sign-in"
                              }),
                              _vm._v("Cuentas por cobrar\n          ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[6]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/cuentasporpagar/lista" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sign-out"
                              }),
                              _vm._v("Cuentas por pagar\n          ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[7]["state"] === true ||
              _vm.arrayBarra[8]["state"] === true ||
              _vm.arrayBarra[9]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-product-hunt"
                          }),
                          _vm._v("Productos\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[9]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/products/productos" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-barcode"
                              }),
                              _vm._v("Productos")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[10]["state"] === true ||
              _vm.arrayBarra[11]["state"] === true ||
              _vm.arrayBarra[12]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-users" }),
                          _vm._v("Personal\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[10]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/personas/empleados" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-user" }),
                              _vm._v("Empleados")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[11]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/personas/usuarios" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-user-plus"
                              }),
                              _vm._v("Usuarios")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[12]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/personas/roles" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-user-secret"
                              }),
                              _vm._v("Roles")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[13]["state"] === true ||
              _vm.arrayBarra[14]["state"] === true ||
              _vm.arrayBarra[15]["state"] === true ||
              _vm.arrayBarra[16]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-shopping-cart"
                          }),
                          _vm._v("Ventas\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[13]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/venta/lista" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-th-list"
                              }),
                              _vm._v("Listado de ventas")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[14]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/venta/nuevo" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-cart-plus"
                              }),
                              _vm._v("Nueva venta")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[15]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/venta/documentos" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-file" }),
                              _vm._v("Documentos")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[16]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/personas/clientes" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-user" }),
                              _vm._v("Clientes")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[17]["state"] === true ||
              _vm.arrayBarra[18]["state"] === true ||
              _vm.arrayBarra[19]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-shopping-basket"
                          }),
                          _vm._v("Compras\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[17]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/compra/lista" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-th-list"
                              }),
                              _vm._v("Listado de compras")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[18]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/compra/nuevo" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-cart-plus"
                              }),
                              _vm._v("Nueva compra")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[19]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/personas/proveedores" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-user" }),
                              _vm._v("Proveedores")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[20]["state"] === true ||
              _vm.arrayBarra[21]["state"] === true ||
              _vm.arrayBarra[22]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dropbox" }),
                          _vm._v("Bodega\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[20]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/bodega/entrada" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sign-in"
                              }),
                              _vm._v("Entrada de producto")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.arrayBarra[21]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/bodega/salida" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sign-out"
                              }),
                              _vm._v("Salida de producto")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[23]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/ajuste" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title"
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-cogs" }),
                          _vm._v("Ajustes\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.arrayBarra[23]["state"] === true
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/productos/localidades" } },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-flag" }),
                              _vm._v("Localidades")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrayBarra[24]["state"] === true
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/dashboard" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { slot: "item-title", to: "/admin/reports" },
                          slot: "item-title"
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-file-text" }),
                          _vm._v("Reportes")
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0efe7828", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efe7828","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/layouts/partials/TheSiteSidebar.vue
// module id = 500
// module chunks = 0